import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { getTicketsSettings, type TicketsSettings } from "@/lib/tickets.functions";

const TicketsContext = createContext<TicketsSettings>({ enabled: false, url: null });

export function TicketsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<TicketsSettings>({ enabled: false, url: null });

  useEffect(() => {
    let alive = true;
    getTicketsSettings()
      .then((s) => {
        if (alive) setSettings(s);
      })
      .catch(() => {
        /* keep defaults */
      });
    return () => {
      alive = false;
    };
  }, []);

  return <TicketsContext.Provider value={settings}>{children}</TicketsContext.Provider>;
}

export function useTickets(): TicketsSettings {
  return useContext(TicketsContext);
}

/**
 * Returns props for an anchor rendering the tickets CTA, or `null` when
 * ticket sales are disabled globally (caller should hide the button).
 */
export function useTicketAnchorProps(): {
  href: string;
  target?: "_blank";
  rel?: string;
} | null {
  const { enabled } = useTickets();
  if (!enabled) return null;
  // The general tickets CTA points to the internal overview page,
  // from where visitors pick a specific film (per-film cta_url) or
  // fall back to the global ticket shop URL.
  return { href: "/tickets" };
}